import React from 'react';
import { useHistory } from 'react-router-dom';
import { IonContent, IonPage } from '@ionic/react';
import { CreateLinkForm } from '../components/Dashboard/Links/CreateLinkForm';
import { LinkModel, LinkDestination } from '../types/link';
import DashboardLayout from '../components/Dashboard/DashboardLayout';
import { LinksService } from '../api';

const NewLink: React.FC = () => {
  const history = useHistory();

  const handleFormSubmit = async (
    link: Partial<LinkModel>, 
    destination: Partial<LinkDestination>, 
    file: File | null
  ) => {
    try {
      // Create the link using the LinksService
      const createdLink = await LinksService.createLink(link, destination);
      
      // If there's a file to upload, handle that separately
      if (file && createdLink.id) {
        await LinksService.uploadFile(createdLink.id, file);
      }

      // Return to links list
      history.push('/links');
    } catch (error) {
      console.error('Error creating link:', error);
      throw error;
    }
  };

  const handleFormCancel = () => {
    history.push('/links');
  };

  return (
    <DashboardLayout>
      <IonPage>
        <IonContent className="ion-padding">
          <CreateLinkForm
            onSubmit={handleFormSubmit}
            onCancel={handleFormCancel}
          />
        </IonContent>
      </IonPage>
    </DashboardLayout>
  );
};

export default NewLink; 